import React, { forwardRef } from 'react';
import { FormattedMessage } from 'react-intl';
import { cx } from '@emotion/css';
import { useReactiveVar } from '@apollo/client';

import { Form, IFormImperativeHandleProps } from '../../../../common/form';
import { ToggleButtonGroup } from '../../../../common/form/toggle-button-group';
import { useStyles } from './ecp-filters-modal-form.styles';
import { IEcpFiltersModalFormProps } from './ecp-filters-modal-form.models';
import {
  serviceTypeFilteringItemsC2C,
  serviceTypeFilteringItems,
  shopTypeFilteringItems,
  specializationTypeFilteringItems,
  specFilterItemsWithMyopia,
} from '../filtering-criteria-items/filtering-criteria-items';
import { C2CMode } from '../../../../common/configuration-settings/configuration-settings.models';
import { setMyopiaControl } from '../../../../../graphql/configuration/configuration.cache';

export const EcpFiltersModalForm = forwardRef<
IFormImperativeHandleProps, IEcpFiltersModalFormProps>(({
  defaultValues, onApplyFilters, c2CMode,
}, ref): JSX.Element => {
  const classes = useStyles();
  const isMyopiaControl = useReactiveVar(setMyopiaControl);

  return (
    <Form
      ref={ref}
      defaultValues={defaultValues}
      onSubmit={onApplyFilters}
    >
      <h2 className={classes.filtersTypeTitle}>
        <FormattedMessage
          id="ecp.filters.modal.serviceType.title"
        />
      </h2>
      <ToggleButtonGroup
        name="services"
        exclusive
        standalone
        size="small"
        variant="outlined"
        // Hide C2C feature from aohm-only fitted users
        options={(c2CMode !== C2CMode.disabled)
          ? serviceTypeFilteringItemsC2C
          : serviceTypeFilteringItems}
        buttonStyles={cx(classes.buttonStyles, classes.c2cButtonStyles)}
        groupStyles={classes.c2cGroupStyles}
      />
      <h2 className={classes.filtersTypeTitle}>
        <FormattedMessage
          id="ecp.spec.additional.title"
        />
      </h2>
      <ToggleButtonGroup
        name="specializations"
        standalone
        size="small"
        variant="outlined"
        options={isMyopiaControl ? specFilterItemsWithMyopia : specializationTypeFilteringItems}
        buttonStyles={classes.buttonStyles}
      />
      <h2 className={classes.filtersTypeTitle}>
        <FormattedMessage
          id="ecp.filters.modal.shopType.title"
        />
      </h2>
      <ToggleButtonGroup
        name="shops"
        standalone
        size="small"
        variant="outlined"
        options={shopTypeFilteringItems}
        buttonStyles={classes.buttonStyles}
      />
    </Form>
  );
});
